import { AccordionItemHeaderElement } from '@typedream/components';
import { TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { createTElementPluginFactory } from '../../plate';
import {
  ELEMENT_ACCORDION_ITEM,
  ELEMENT_ACCORDION_ITEM_CONTENT,
  ELEMENT_ACCORDION_ITEM_HEADER,
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_PARAGRAPH,
} from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { AccordionItemContentElementEditor } from './components/AccordionItemContentElement';
import { AccordionItemElementEditor } from './components/AccordionItemElement';
import { withAccordionItem } from './withAccordionItem';

const createAccordionItemHeaderPlugin = createTElementPluginFactory({
  key: ELEMENT_ACCORDION_ITEM_HEADER,
  component: AccordionItemHeaderElement,
  options: {
    meta: {
      title: 'Accordion Item Header',
    },
    format: {
      formatType: 'block',
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: ['connect_data'],
      validChildrenTypes: [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3],
    },
    overrideChildOptions: {
      isResizable: false,
      isDraggable: false,
      isDroppable: false,
    },
  },
});

const createAccordionItemContentPlugin = createTElementPluginFactory({
  key: ELEMENT_ACCORDION_ITEM_CONTENT,
  component: AccordionItemContentElementEditor,
  options: {
    meta: {
      title: 'Accordion Item Content',
    },
    format: {
      formatType: 'block',
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: ['connect_data'],
    },
  },
});

export const createAccordionItemPlugin = createTElementPluginFactory({
  key: ELEMENT_ACCORDION_ITEM,
  component: withDropTarget(AccordionItemElementEditor as ComponentType<TRenderElementProps>),
  withOverrides: withAccordionItem,
  plugins: [createAccordionItemHeaderPlugin(), createAccordionItemContentPlugin()],
  options: {
    isSelectable: true,
    isResizable: false,
    isDraggable: true,
    isDroppable: true,
    meta: {
      title: 'Accordion Item',
    },
    format: {
      formatType: 'block',
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: ['background', 'backgroundImage', 'backgroundDarken', 'connect_data'],
      validChildrenTypes: [ELEMENT_ACCORDION_ITEM_HEADER, ELEMENT_ACCORDION_ITEM_CONTENT],
    },
  },
});
